<h2>Inbetriebnahme abschließen</h2>

<p></p>

<ng-container *ngIf="gridRegistrationErrorMessage$ | async as relatedGrAndErrors; else noErrors">
  <app-hint-card [outlined]="true" [type]="'danger'">
    <div [innerHTML]="'<p>' + relatedGrAndErrors + '</p>' | safeHtmlPipe"></div>
  </app-hint-card>
  <p>
    Um die Inbetriebnahme abschließen zu können, müssen vorher alle verknüpften Netzanmeldungen im richtigen
    Zustand sein.
  </p>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-raised-button color="primary" id="modal-cancel-button" (click)="cancel()">Schließen</button>
  </div>
</ng-container>
<ng-template #noErrors>
  <form [formGroup]="currentForm">
    <div fxLayout="row" fxFlexAlign="stretch">
      <mat-form-field appearance="outline" fxFlex="35" name="date" style="margin-right: 1rem">
        <mat-label>Datum der Inbetriebnahme</mat-label>
        <input
          matInput
          formControlName="supplyAppointment"
          [matDatepicker]="supplyAppointment"
          placeholder="Inbetriebnahmedatum:" />
        <mat-datepicker-toggle matSuffix [for]="supplyAppointment"></mat-datepicker-toggle>
        <mat-datepicker #supplyAppointment></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-accordion class="example-headers-align">
      <mat-expansion-panel
        class="mat-elevation-z0"
        expanded="true"
        *ngFor="let item of actionFormGroups.controls; let itemIndex = index"
        [formGroupName]="itemIndex">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span *ngIf="!item.get('actionType').value">Neue Aktion</span>
            <span *ngIf="item.get('actionType').value">
              {{ item.get('actionType').value | actionTypePipe : 'power' : 'displayName' }}
            </span>
          </mat-panel-title>
          <mat-panel-description>
            <span>
              <span *ngIf="item.get('deviceDesignation').value">
                {{ item.get('deviceDesignation').value }}
              </span>
              <span *ngIf="item.get('connectionPower').value">
                : {{ item.get('connectionPower').value | number : undefined : 'de-DE' }}
                {{ connectionPowerUnit }}
              </span>
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <h2>Zählerwechselinformationen</h2>
        <div fxLayout="row" fxLayoutGap="6em">
          <div>
            <h3>Alter Zähler</h3>
            <app-metering-device-formpart
              [formGroup]="item.get('existingDevice')"></app-metering-device-formpart>
          </div>
          <div>
            <h3>Neuer Zähler</h3>
            <app-metering-device-formpart [formGroup]="item.get('newDevice')"></app-metering-device-formpart>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-after-meter-change" (click)="confirm()">
      <span>Abschicken</span>
    </button>
  </div>
</ng-template>
